import {showErrorMessage} from '@/helper';

export default {
    getAll(clientId) {
        return new Promise((resolve, reject) => {
            http.get(`api/clients/${clientId}/forms/`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    fetchRecords(clientId, body) {
        return new Promise((resolve, reject) => {
            http.post(`api/clients/${clientId}/forms/list`, {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveForm(clientId, data) {
        // ready for file upload
        /*const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            if (key === 'added_files') {
                value.forEach(file => {
                    formData.append('added_files[]', file);
                });
            } else if (key === 'data') {
                formData.append(key, JSON.stringify(value));
            }
            else {
                formData.append(key, value);
            }
        });*/
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/forms' + (data.id ? '/' + data.id : ''), data/*, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }*/).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject([]);
            });
        });
    },

    deleteForm(clientId, recordId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId + '/forms/' + recordId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    }
}
